import { render, staticRenderFns } from "./akses_pangan.vue?vue&type=template&id=6f6e54ae&"
import script from "./akses_pangan.vue?vue&type=script&lang=js&"
export * from "./akses_pangan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports